import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "./const";

class shiftCreditCardService {
  getAvailableForCreditCardSaveShifts(id: any) {
    if (id) {
      return axios.get(
        API_URL + "shiftcreditcard/getavailableshifts?shiftsentityid=" + id,
        {
          headers: authHeader(),
        }
      );
    }
    return axios.get(API_URL + "shiftcreditcard/getavailableshifts", {
      headers: authHeader(),
    });
  }

  postAvailableForCreditCardSaveShift(companyBanks: any) {
    console.log(companyBanks);
    return axios.post(
      API_URL + "shiftcreditcard/availabletocomplete",
      companyBanks,
      { headers: authHeader() }
    );
  }
}

export default new shiftCreditCardService();
